import { Location } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Subject, debounceTime } from 'rxjs';
import {
  DtMeterInstallationInvoiceDetailsDto,
  DtMeterInstallationInvoiceInstalledDt,
} from 'src/app/models/dt-meter-installation-invoice.model';
import { AuthService } from 'src/app/services/auth.service';
import { InstallationService } from 'src/app/services/installation.service';
import { TranslationService } from 'src/app/services/translation.service';

@Component({
  selector: 'app-dt-meter-installation-invoice-details',
  templateUrl: './dt-meter-installation-invoice-details.component.html',
  styleUrls: ['./dt-meter-installation-invoice-details.component.scss'],
})
export class DtMeterInstallationInvoiceDetailsComponent implements OnInit {
  invoice: DtMeterInstallationInvoiceDetailsDto = new DtMeterInstallationInvoiceDetailsDto();
  currency: string = '';

  installedDts: DtMeterInstallationInvoiceInstalledDt[] = [];
  installedDtCount: number = 0;
  installedDtCurrentPage: number = 1;
  installedDtPageSize: number = 10;
  installedDtSearchText: string = '';
  installedDtSearchTextUpdate = new Subject<string>();

  buName: string;
  utName: string;
  hasCimDataIntegration: boolean = false;

  private invoiceDbId: number = 0;

  constructor(
    private route: ActivatedRoute,
    private toastr: ToastrService,
    private installationService: InstallationService,
    private translationService: TranslationService,
    private authService: AuthService,
    private location: Location
  ) {
    this.currency = localStorage.getItem('currency') || '';
    this.buName = this.translationService.getByKeyFromStorage('BU');
    this.utName = this.translationService.getByKeyFromStorage('UT');
    this.hasCimDataIntegration = this.authService.hasCimDataIntegration;
    this.installedDtSearchTextUpdate.pipe(debounceTime(500)).subscribe((_) => {
      if (this.installedDtSearchText == '') this.installedDtSearch();
    });
  }

  ngOnInit(): void {
    this.invoiceDbId = parseInt(this.route.snapshot.paramMap.get('id') || '0');
    this.getInvoice(this.invoiceDbId);
    this.reloadInstalledDtTable(1);
  }

  goBack() {
    this.location.back();
  }

  get paymentProgress(): number {
    const total = this.invoice.totalAmount ?? 0;
    if (total <= 0) return 0;
    return Math.round(((this.invoice.amountPaid ?? 0) / total) * 100);
  }

  getInvoice(id: number) {
    this.installationService.getDtMeterInstallationInvoiceById(id).subscribe({
      next: (response) => {
        const responseData = response.body;
        if (responseData?.status === 200 || responseData?.status === 'OK') {
          this.invoice = responseData.data;
        } else {
          this.toastr.error(responseData?.message);
        }
      },
      error: (_) => this.toastr.error('Error occured'),
    });
  }

  installedDtSearch() {
    this.reloadInstalledDtTable(1);
  }

  installedDtPageChange(value: any) {
    this.installedDtCurrentPage = value;
    this.reloadInstalledDtTable();
  }

  reloadInstalledDtTable(page: any = null) {
    if (page) this.installedDtCurrentPage = page;
    const obj = {
      invoiceId: this.invoiceDbId,
      pageInfo: {
        page: this.installedDtCurrentPage,
        pageSize: this.installedDtPageSize,
      },
      search: this.installedDtSearchText,
    };

    this.installedDts = [];
    this.installedDtCount = 0;
    this.installationService.getDtMeterInstallationInvoiceInstalledDts(obj).subscribe({
      next: (response) => {
        const responseData = response.body;
        if (responseData?.status === 200 || responseData?.status === 'OK') {
          this.installedDts = responseData.data.data;
          this.installedDtCount = responseData.data.count;
        } else {
          this.toastr.error(responseData?.message);
        }
      },
      error: (_) => this.toastr.error('Error occured'),
    });
  }
}
